
<template>
    
    <section class="sin">
        <div class="panel">
            <div class="panel-heading">
                <h2>Government Required Information</h2>
            </div>
            <div class="panel-body">
                <div v-if="text" v-html="text.SIN[0].text"></div>
           

                <form @submit.prevent="update()">
                        
                        <div class="form-group">
                            <input v-model="legalName" type="text" class="form-control" placeholder="Full Legal Name">
                        </div>

                        <div class="form-group">
                            <label>Do You Have a Canadian SIN #?</label>
                            <div>
                                <input v-model="hasSin" id="no_sin" value="false" name="has_sin" type="radio">
                                <label for="no_sin" class="check-label">No</label>
                                <input v-model="hasSin" id="yes_sin" value="true" name="has_sin" type="radio">
                                <label for="yes_sin" class="check-label">Yes</label>
                            </div>
                        </div>

                        <div class="form-group" v-if="hasSin == 'true'">
                            <input type="text" v-model="sin" class="form-control" placeholder="Canadian SIN #">
                        </div>
                        
                        <div class="form-group">
                            <button type="submit" class="btn btn-success">Submit</button>
                        </div>
                </form>
  
             </div>
        </div>
    </section>

</template>

<script>

import users from '../services/users';
import cms from '../services/cms';

import { groupBy } from 'lodash';
import toastr from 'toastr';

export default {
    data() {
        return {
            sin:null,
            hasSin: null,
            legalName: null,
            text: null
        }
    },
    components: {

    },
    created() {
        this.getText();
    },
    mounted() {

    },
    methods: {
        getText() {
            cms.get('SIN').then((response)=> {
                this.text = groupBy(response.components, (c)=> { return c.name });
            });
        },
        update() {
            if (!this.legalName || this.legalName.trim() === '') {
                toastr.error('Please enter your full legal name');
                return;
            }
            if (this.hasSin == 'true' && !this.sin) {
                toastr.error('Please enter your SIN');
                return;
            }
            const data = {
                legalName: this.legalName.trim(),
                sin: this.sin
            }
            users.selfUpdate(this, data).then((response)=> {
                if (response.data.success === true) {
                    this.$bus.$emit('sinSubmitted')
                    toastr.success('Thank you!');
                    localStorage.setItem('sinSubmitted',true);
                    this.$router.push('/');

                } else {
                    toastr.error('Error submitting');
                }              

                
            });
        }
    },
    computed: {

    }
}
</script>

<style lang="scss" scoped>
    .panel-body {
        padding:2rem!important;
    }
    input[type=radio] {
        display:none;
    }
    input[type=radio] + .check-label::before {
        content:"\f096";
        font-family: 'FontAwesome';
        margin-right:.4rem;
        position: relative;
        top: 1px;
    }
    input[type=radio]:checked + .check-label::before {
        content:"\f046";      
    }
</style>


// WEBPACK FOOTER //
// SIN.vue?6082a536